getExponentialDelay